import axios from 'axios';
import React, { useContext, useState, useEffect } from 'react';
import {
  Badge,
  Box,
  Button,
  CircularProgress,
  Icon,
  Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { AuthContext } from '@/js/shared/context/AuthContext';
import { ConferenceContext } from '@/js/shared/context/ConferenceContext';
import { VideoChatContext } from '@/js/shared/context/VideoChatContext';
import SearchBar from '@/js/shared/components/ui/SearchBar';
import UserAvatar from '@/js/shared/components/ui/UserAvatar';
import CoChipSmall from '@/js/shared/components/ui/CoChipSmall';
import { useParticipantList } from '@/hooks/useParticipantList';

const StyledBadge = withStyles(() => ({
  badge: {
    right: 2,
    top: 30,
    border: `1px solid #FFFFFF`,
    backgroundColor: `#32CD32`,
    padding: '0 0px',
  },
}))(Badge);

const infoList = (infos) => {
  const filtered = infos.filter((info) => !!info);
  return filtered.join(', ');
};

export const ParticipantList = React.memo(
  withStyles((theme) => ({
    list: {
      position: 'relative',
      [theme.breakpoints.up('md')]: {
        position: 'absolute',
      },
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflowY: 'auto',
      backgroundColor: theme.palette.background.shadedown_20,
    },
    profileLink: {
      padding: '5px 8px',
    },
    profileInfo: {
      fontSize: '0.8rem',
    },
    profileOffline: {
      fontSize: '0.8rem',
    },
    userName: {
      textDecoration: 'underline',
      textTransform: 'capitalize',
      padding: 0,
      marginRight: 5,
      lineHeight: '1rem',
      opacity: 0.8,
      '&:hover': {
        opacity: 1,
        textDecoration: 'underline',
      },
    },
    videoImage: {
      width: 160,
      height: 'auto',
    },
    endIcon: {
      marginLeft: 0,
    },
  }))((props) => {
    const {
      participants,
      totalCount,
      loading,
      keyword,
      fullList,
      setKeyword,
      loadParticipants,
      showMore,
      handleSearch,
    } = useParticipantList({
      conferenceId: props.conferenceId,
      programRoomId: props.roomId,
    });
    const { authState } = useContext(AuthContext); // Hämta Context
    const { openUserPopup } = useContext(ConferenceContext); // Hämta Context
    const { videoChatId, handleSendInvitation } = useContext(VideoChatContext); // Hämta Context

    useEffect(() => {
      loadParticipants();
    }, [props.update]);

    const handleUserClick = (user) => {
      openUserPopup(user, keyword ? participants : fullList);
    };
    return (
      <Box className={props.classes.list} pt={1}>
        {/* {window.SETTINGS.USE_VIDEOCHAT && (
          <Box align="center" pb={1}>
            {window.LANG.MINGLE_TXT}
            <br />
            <img
              className={props.classes.videoImage}
              src="/images/watch-together.jpg"
            />
            <br />
            <Button
              startIcon={<Icon>videocam</Icon>}
              variant="contained"
              size="small"
              color="primary"
              disabled={videoChatId !== null}
              onClick={() => handleSendInvitation()}
            >
              {window.LANG.MINGLE_BTN}
            </Button>
          </Box>
        )} */}
        <Box p={0.5}>
          <SearchBar onSearch={handleSearch} keyword={keyword} />
        </Box>

        {participants.map((user) => {
          return (
            <Box
              className={props.classes.profileLink}
              display="flex"
              key={user.id}
            >
              <Box pr={2}>
                <StyledBadge
                  invisible={!user.online}
                  variant="dot"
                  color="primary"
                >
                  {<UserAvatar user={user} />}
                </StyledBadge>
              </Box>
              <Box flexGrow={1}>
                <Button
                  className={props.classes.userName}
                  classes={{ endIcon: props.classes.endIcon }}
                  component="a"
                  onClick={() => handleUserClick(user)}
                  endIcon={<Icon>keyboard_arrow_down</Icon>}
                >
                  {user.full_name}
                </Button>
                <Typography
                  variant="body2"
                  className={props.classes.profileInfo}
                >
                  <em>
                    {infoList([user.title, user.company, user.location_city])}
                  </em>
                </Typography>

                {user.tags
                  .map((tag) => (
                    <CoChipSmall
                      size="smaller"
                      key={tag.id}
                      tagtype={tag.type}
                      label={tag.title}
                    />
                  ))
                  .reduce((r, a) => r.concat(', ', a), [])
                  .slice(1)}
              </Box>

              {/* {videoChatId !== null && authState.user.id !== user.id && (
                <Box>
                  <Button
                    onClick={() => handleSendInvitation(user)}
                    variant="contained"
                    size="small"
                    color="primary"
                    startIcon={<Icon>videocam</Icon>}
                  >
                    +ADD
                  </Button>
                </Box>
              )} */}
            </Box>
          );
        })}
        <br />
        <Box align="center" pb={3}>
          {loading ? (
            <CircularProgress />
          ) : (
            totalCount > participants.length && (
              <Button
                startIcon={<Icon>add_circle</Icon>}
                size="small"
                color="primary"
                onClick={() => showMore()}
              >
                Load more
              </Button>
            )
          )}
        </Box>
      </Box>
    );
  })
);
